(function () {
  'use strict';

  var Core = window.TMPPartsFinderCore;
  if (!Core || customElements.get('tmp-atf-parts-finder')) return;

  var text = function (value) { return Core.clean(value, 300); };

  class TMPATFPartsFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = this.readConfig();
      this.applicationSelect = this.querySelector('[data-atf-application]');
      this.makeSelect = this.querySelector('[data-atf-make]');
      this.modelSelect = this.querySelector('[data-atf-model]');
      this.variantField = this.querySelector('[data-atf-variant-field]');
      this.variantLabel = this.querySelector('[data-atf-variant-label]');
      this.variantSelect = this.querySelector('[data-atf-variant]');
      this.savedSelect = this.querySelector('[data-atf-saved]');
      this.findButton = this.querySelector('[data-atf-find]');
      this.resetButton = this.querySelector('[data-atf-reset]');
      this.fieldsRegion = this.querySelector('[data-atf-finder-form]');
      this.matchRegion = this.querySelector('[data-atf-match]');
      this.statusRegion = this.querySelector('[data-atf-status]');
      this.alertRegion = this.querySelector('[data-atf-alert]');
      this.finderFace = this.querySelector('[data-atf-finder-face]');
      this.authPanel = this.querySelector('[data-atf-auth]');
      this.authOptions = Array.from(this.querySelectorAll('.atf-pf__auth-option'));
      this.state = { families: [], family: null, match: null };
      this.requests = { makes: 0, models: 0 };
      this.customSelects = new Map();
      this.storage = Core.storageAdapter(window.localStorage, this.config.storageKey, this.config.maxProfiles);
      [this.applicationSelect, this.makeSelect, this.modelSelect, this.variantSelect, this.savedSelect].forEach((select) => this.enhanceSelect(select));
      this.bindEvents();
      this.resetSelect(this.makeSelect, this.string('chooseApplicationFirst', 'Choose an application first'));
      this.resetSelect(this.modelSelect, this.string('chooseMakeFirst', 'Choose a make first'));
      this.resetVariant();
      this.renderSaved(this.storage.read());
      this.loadApplications().then((loaded) => {
        if (!loaded) return;
        if (this.config.customer && this.config.customer.signedIn) {
          this.loadAccountProfiles();
          this.resumeHeroPendingSave();
        }
      });
    }

    readConfig() {
      var script = this.querySelector('[data-atf-config]');
      try {
        return JSON.parse(script ? script.textContent : '{}');
      } catch (error) {
        return { strings: {} };
      }
    }

    string(key, fallback) {
      return text(this.config.strings && this.config.strings[key]) || fallback;
    }

    apiBase() {
      return Core.safeEndpoint(this.config.resolverApiBaseUrl, window.location.origin);
    }

    accountEndpoint() {
      var endpoint = Core.safeEndpoint(this.config.accountEndpoint, window.location.origin);
      if (!endpoint) return '';
      try {
        var parsed = new URL(endpoint, window.location.origin);
        return parsed.origin === window.location.origin ? parsed.href.replace(/\/$/, '') : '';
      } catch (error) {
        return '';
      }
    }

    partsFinderTarget() {
      try {
        var target = new URL(this.config.partsFinderUrl || '/pages/parts-finder', window.location.origin);
        return target.origin === window.location.origin ? target : null;
      } catch (error) {
        return null;
      }
    }

    async fetchJSON(url, options) {
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 12000);
      try {
        var response = await fetch(url, Object.assign({
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          signal: controller.signal
        }, options || {}));
        if (!response.ok) {
          var failure = new Error('HTTP ' + response.status);
          failure.status = response.status;
          throw failure;
        }
        var contentType = response.headers.get('content-type') || '';
        if (contentType.indexOf('application/json') === -1) throw new Error('Expected JSON response');
        return await response.json();
      } finally {
        window.clearTimeout(timeout);
      }
    }

    bindEvents() {
      this.applicationSelect.addEventListener('change', () => this.onApplicationChange());
      this.makeSelect.addEventListener('change', () => this.onMakeChange());
      this.modelSelect.addEventListener('change', () => this.onModelChange());
      if (this.variantSelect) this.variantSelect.addEventListener('change', () => this.onVariantChange());
      this.savedSelect.addEventListener('change', () => this.useSavedProfile());
      this.findButton.addEventListener('click', () => this.findMatch());
      if (this.resetButton) this.resetButton.addEventListener('click', () => this.startAgain());
      this.querySelectorAll('.atf-pf__auth form').forEach((form) => {
        form.addEventListener('submit', () => this.preservePendingSave());
      });
      this.authOptions.forEach((option) => {
        option.addEventListener('toggle', () => {
          if (!option.open) return;
          this.authOptions.forEach(function (other) {
            if (other !== option) other.open = false;
          });
        });
      });
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-atf-save]')) this.saveMatch();
        if (event.target.closest('[data-atf-use-details]')) this.useDetails();
        if (event.target.closest('[data-atf-auth-close]')) this.closeAuth(true);
      });
    }

    enhanceSelect(select) {
      if (!select || this.customSelects.has(select)) return;
      var label = this.querySelector('label[for="' + CSS.escape(select.id) + '"]');
      var wrapper = document.createElement('div');
      wrapper.className = 'atf-pf__custom-select';
      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'atf-pf__select-trigger';
      trigger.id = select.id + '-Trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      var menu = document.createElement('ul');
      menu.className = 'atf-pf__select-menu';
      menu.id = select.id + '-Menu';
      menu.setAttribute('role', 'listbox');
      menu.hidden = true;
      trigger.setAttribute('aria-controls', menu.id);
      if (label) {
        label.id = label.id || select.id + '-Label';
        label.htmlFor = trigger.id;
        trigger.setAttribute('aria-labelledby', label.id + ' ' + trigger.id);
        menu.setAttribute('aria-labelledby', label.id);
      }
      wrapper.append(trigger, menu);
      select.insertAdjacentElement('afterend', wrapper);
      select.classList.add('atf-pf__native-select');
      select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');
      this.customSelects.set(select, { wrapper: wrapper, trigger: trigger, menu: menu });

      var close = (restoreFocus) => {
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) trigger.focus();
      };
      var options = () => Array.from(menu.querySelectorAll('[role="option"]'));
      var focusOption = (direction) => {
        var items = options();
        if (!items.length) return;
        var index = items.indexOf(document.activeElement);
        if (direction === 'first') index = 0;
        else if (direction === 'last') index = items.length - 1;
        else index = index < 0 ? 0 : (index + direction + items.length) % items.length;
        items[index].focus();
      };
      var open = () => {
        if (trigger.disabled) return;
        this.customSelects.forEach(function (other) {
          if (other.menu === menu) return;
          other.menu.hidden = true;
          other.trigger.setAttribute('aria-expanded', 'false');
        });
        var bounds = trigger.getBoundingClientRect();
        var below = Math.max(0, window.innerHeight - bounds.bottom - 16);
        var above = Math.max(0, bounds.top - 16);
        var opensAbove = below < 220 && above > below;
        menu.dataset.placement = opensAbove ? 'above' : 'below';
        menu.style.maxHeight = Math.max(160, Math.min(340, opensAbove ? above : below)) + 'px';
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(() => {
          var target = menu.querySelector('[aria-selected="true"]') || menu.querySelector('[role="option"]');
          if (target) {
            target.focus({ preventScroll: true });
            target.scrollIntoView({ block: 'nearest' });
          }
        });
      };
      var choose = (item) => {
        if (!item) return;
        select.value = item.dataset.value || '';
        this.syncCustomSelect(select);
        close(true);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      };

      trigger.addEventListener('click', () => menu.hidden ? open() : close(false));
      trigger.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        open();
        window.requestAnimationFrame(() => focusOption(event.key === 'Home' ? 'first' : event.key === 'End' ? 'last' : event.key === 'ArrowUp' ? -1 : 1));
      });
      menu.addEventListener('click', (event) => choose(event.target.closest('[role="option"]')));
      menu.addEventListener('wheel', (event) => {
        if (menu.scrollHeight <= menu.clientHeight) return;
        event.preventDefault();
        menu.scrollTop += event.deltaY;
      }, { passive: false });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { event.preventDefault(); close(true); return; }
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); choose(event.target.closest('[role="option"]')); return; }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); focusOption(event.key === 'ArrowDown' ? 1 : -1); return; }
        if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); focusOption(event.key === 'Home' ? 'first' : 'last'); }
      });
      wrapper.addEventListener('focusout', () => window.setTimeout(() => {
        if (!wrapper.contains(document.activeElement)) close(false);
      }, 0));
      select.addEventListener('change', () => this.syncCustomSelect(select));
      this.syncCustomSelect(select);
    }

    syncCustomSelect(select) {
      var custom = this.customSelects.get(select);
      if (!custom) return;
      var selected = select.selectedOptions && select.selectedOptions[0];
      custom.trigger.textContent = selected ? selected.textContent : '';
      custom.trigger.disabled = select.disabled;
      custom.trigger.dataset.placeholder = select.value ? 'false' : 'true';
      custom.menu.replaceChildren();
      Array.from(select.options).forEach(function (option) {
        var item = document.createElement('li');
        item.setAttribute('role', 'option');
        item.tabIndex = -1;
        item.dataset.value = option.value;
        item.setAttribute('aria-selected', option.value === select.value ? 'true' : 'false');
        item.textContent = option.textContent;
        custom.menu.append(item);
      });
      if (select.disabled) {
        custom.menu.hidden = true;
        custom.trigger.setAttribute('aria-expanded', 'false');
      }
    }

    resetSelect(select, label) {
      if (!select) return;
      select.replaceChildren(new Option(label, ''));
      select.disabled = true;
      this.syncCustomSelect(select);
    }

    resetVariant() {
      if (!this.variantSelect || !this.variantField) return;
      if (this.variantLabel) this.variantLabel.textContent = this.string('requiredVariantLabel', 'Exact model / version');
      this.resetSelect(this.variantSelect, this.string('chooseModelFirst', 'Choose a model / series first'));
      this.variantField.hidden = true;
    }

    focusSelect(select) {
      var custom = select && this.customSelects.get(select);
      if (custom) custom.trigger.focus({ preventScroll: true });
      else if (select) select.focus({ preventScroll: true });
    }

    populateSelect(select, placeholder, rows, valueKey, labelKey, countKey) {
      select.replaceChildren(new Option(placeholder, ''));
      rows.forEach(function (row) {
        var value = text(row[valueKey]);
        var label = text(row[labelKey]) || value;
        var count = Number(row[countKey]);
        if (!value || !label) return;
        var option = new Option(Number.isFinite(count) && count > 0 ? label + ' (' + count + ')' : label, value);
        option.dataset.label = label;
        Object.keys(row).forEach(function (key) {
          var dataKey = key.replace(/_([a-z])/g, function (_, letter) { return letter.toUpperCase(); });
          if (row[key] != null && typeof row[key] !== 'object') option.dataset[dataKey] = String(row[key]);
        });
        select.append(option);
      });
      select.disabled = select.options.length < 2;
      this.syncCustomSelect(select);
    }

    selectedLabel(select) {
      var option = select && select.selectedOptions && select.selectedOptions[0];
      return option ? text(option.dataset.label || option.textContent.replace(/\s+\(\d+\)$/, '')) : '';
    }

    setSelectByLabel(select, label) {
      var target = text(label).toLowerCase();
      var option = Array.from(select.options).find(function (item) {
        return text(item.dataset.label || item.textContent.replace(/\s+\(\d+\)$/, '')).toLowerCase() === target;
      });
      if (!option) return false;
      select.value = option.value;
      this.syncCustomSelect(select);
      return true;
    }

    async loadApplications(attempt) {
      attempt = Number(attempt) || 0;
      var base = this.apiBase();
      if (!base) {
        this.resetSelect(this.applicationSelect, this.string('apiUnavailable', 'Applications unavailable — try again shortly'));
        this.setAlert(this.string('apiUnavailable', 'The finder data could not be loaded. Try again shortly.'));
        return false;
      }
      try {
        var data = await this.fetchJSON(base + '/api/catalog/applications');
        var rows = Core.rowsFrom(data, ['applications', 'rows', 'results']).filter(function (row) {
          var key = text(row.application_key || row.key || row.label).toLowerCase();
          return key !== 'other' && key !== 'other equipment';
        });
        this.populateSelect(this.applicationSelect, this.string('applicationPlaceholder', 'Choose application'), rows, 'label', 'label', 'equipment_count');
        this.updateProgressiveStage();
        return true;
      } catch (error) {
        if (attempt < 2) {
          await new Promise(function (resolve) { window.setTimeout(resolve, 300 * (attempt + 1)); });
          return this.loadApplications(attempt + 1);
        }
        this.resetSelect(this.applicationSelect, this.string('apiUnavailable', 'Applications unavailable — try again shortly'));
        this.setAlert(this.string('apiUnavailable', 'The finder data could not be loaded. Try again shortly.'));
        this.updateProgressiveStage();
        return false;
      }
    }

    async onApplicationChange() {
      this.clearMatch();
      this.state.families = [];
      this.state.family = null;
      this.updateFindLabel();
      this.resetSelect(this.modelSelect, this.string('chooseMakeFirst', 'Choose a make first'));
      this.resetVariant();
      var application = this.selectedLabel(this.applicationSelect);
      if (!application) {
        this.resetSelect(this.makeSelect, this.string('chooseApplicationFirst', 'Choose an application first'));
        this.updateProgressiveStage();
        return;
      }
      this.updateProgressiveStage();
      var request = ++this.requests.makes;
      this.resetSelect(this.makeSelect, this.string('loadingMakes', 'Loading makes…'));
      try {
        var data = await this.fetchJSON(this.apiBase() + '/api/catalog/manufacturers?application=' + encodeURIComponent(application));
        if (request !== this.requests.makes) return;
        this.populateSelect(this.makeSelect, this.string('makePlaceholder', 'Choose make'), Core.rowsFrom(data, ['manufacturers', 'rows', 'results']), 'manufacturer', 'manufacturer', 'equipment_count');
      } catch (error) {
        if (request !== this.requests.makes) return;
        this.resetSelect(this.makeSelect, this.string('apiUnavailable', 'Makes unavailable — try again'));
        this.setAlert(this.string('apiUnavailable', 'The finder data could not be loaded. Try again shortly.'));
      }
    }

    async onMakeChange() {
      this.clearMatch();
      this.state.families = [];
      this.state.family = null;
      this.resetVariant();
      var application = this.selectedLabel(this.applicationSelect);
      var make = this.selectedLabel(this.makeSelect);
      if (!application || !make) {
        this.resetSelect(this.modelSelect, this.string('chooseMakeFirst', 'Choose a make first'));
        this.updateProgressiveStage();
        return;
      }
      this.updateProgressiveStage();
      var request = ++this.requests.models;
      this.resetSelect(this.modelSelect, this.string('loadingModels', 'Loading models…'));
      try {
        var url = this.apiBase() + '/api/catalog/models?application=' + encodeURIComponent(application) + '&manufacturer=' + encodeURIComponent(make) + '&limit=2500';
        var data = await this.fetchJSON(url);
        if (request !== this.requests.models) return;
        this.state.families = Core.groupModels(Core.rowsFrom(data, ['models', 'rows', 'results']), { application: application, manufacturer: make });
        this.modelSelect.replaceChildren(new Option(this.string('modelPlaceholder', 'Choose model / series'), ''));
        this.state.families.forEach((family) => {
          var option = new Option(family.label, family.key);
          option.dataset.label = family.label;
          this.modelSelect.append(option);
        });
        this.modelSelect.disabled = this.modelSelect.options.length < 2;
        this.syncCustomSelect(this.modelSelect);
      } catch (error) {
        if (request !== this.requests.models) return;
        this.resetSelect(this.modelSelect, this.string('apiUnavailable', 'Models unavailable — try again'));
        this.setAlert(this.string('apiUnavailable', 'The finder data could not be loaded. Try again shortly.'));
      }
    }

    onModelChange() {
      this.clearMatch();
      this.state.family = this.state.families.find((family) => family.key === this.modelSelect.value) || null;
      this.resetVariant();
      if (this.state.family && this.state.family.requiresVariant && this.state.family.hasVariants && this.variantSelect && this.variantField) {
        if (this.variantLabel) this.variantLabel.textContent = this.string('requiredVariantLabel', 'Exact model / version');
        this.variantSelect.replaceChildren(new Option(this.string('requiredVariantPlaceholder', 'Choose exact model / version (required)'), ''));
        this.state.family.variants.forEach((variant) => {
          var option = new Option(variant.label, variant.key);
          option.dataset.label = variant.label;
          this.variantSelect.append(option);
        });
        this.variantSelect.disabled = false;
        this.variantField.hidden = false;
        this.syncCustomSelect(this.variantSelect);
      }
      this.findButton.disabled = !this.state.family || Boolean(this.state.family.requiresVariant);
      this.updateProgressiveStage();
    }

    onVariantChange() {
      this.clearMatch();
      this.findButton.disabled = !this.state.family || Boolean(this.state.family.requiresVariant && !(this.variantSelect && this.variantSelect.value));
      this.updateProgressiveStage();
    }

    updateFindLabel() {
      this.findButton.textContent = Core.terminology(this.selectedLabel(this.applicationSelect), this.config.strings).find;
    }

    findMatch() {
      this.setAlert('');
      if (!this.applicationSelect.value || !this.makeSelect.value || !this.modelSelect.value || !this.state.family) {
        this.setAlert(this.string('completeDetails', 'Choose an application, make and model / series first.'));
        return;
      }
      var family = this.state.family;
      var variant = family.requiresVariant && this.variantSelect
        ? family.variants.find((item) => item.key === this.variantSelect.value) || null
        : null;
      if (family.requiresVariant && !variant) {
        this.setAlert(this.string('requiredVariantMessage', 'Choose the exact model / version before continuing.'));
        this.focusSelect(this.variantSelect);
        return;
      }
      var selected = variant || family;
      var applicationOption = this.applicationSelect.selectedOptions[0];
      var application = this.selectedLabel(this.applicationSelect);
      var make = this.selectedLabel(this.makeSelect);
      this.state.match = Core.sanitizeProfile({
        application: application,
        applicationKey: applicationOption.dataset.applicationKey || applicationOption.value,
        make: make,
        model: selected.modelCode,
        modelFamily: family.modelCode,
        variant: variant ? variant.modelCode : '',
        isBroadMatch: Boolean(family.hasVariants && !variant),
        displayName: [make, selected.modelCode].filter(Boolean).join(' '),
        canonicalEquipmentId: selected.canonicalEquipmentId,
        equipmentIds: selected.equipmentIds,
        categoryEquipmentIds: selected.categoryEquipmentIds
      });
      this.renderMatch();
      this.setStatus('');
      this.updateProgressiveStage();
    }

    renderMatch() {
      this.matchRegion.replaceChildren();
      if (!this.state.match) {
        this.matchRegion.hidden = true;
        return;
      }
      var words = Core.terminology(this.state.match.application, this.config.strings);
      var card = document.createElement('article');
      card.className = 'atf-pf__match-card';
      var eyebrow = document.createElement('p');
      eyebrow.className = 'atf-pf__match-eyebrow';
      eyebrow.textContent = this.string('matchEyebrow', 'This is the match');
      var title = document.createElement('h3');
      title.textContent = this.state.match.displayName;
      var divider = document.createElement('span');
      divider.className = 'atf-pf__match-divider';
      divider.setAttribute('aria-hidden', 'true');
      divider.textContent = '•';
      var meta = document.createElement('p');
      meta.className = 'atf-pf__match-meta';
      meta.textContent = this.state.match.application;
      var summary = document.createElement('div');
      summary.className = 'atf-pf__match-summary';
      summary.append(title, divider, meta);
      card.append(eyebrow, summary);
      if (this.state.match.isBroadMatch) {
        var note = document.createElement('p');
        note.className = 'atf-pf__match-note';
        note.textContent = this.string('familyMatchNote', 'Results will cover the selected model family. Check the exact model version and any fitment note before ordering.');
        card.append(note);
      }
      var actions = document.createElement('div');
      actions.className = 'atf-pf__match-actions';
      var save = document.createElement('button');
      save.type = 'button';
      save.className = 'atf-pf__match-action atf-pf__match-action--secondary';
      save.dataset.atfSave = '';
      save.textContent = words.save;
      var use = document.createElement('button');
      use.type = 'button';
      use.className = 'atf-pf__match-action';
      use.dataset.atfUseDetails = '';
      use.textContent = words.use;
      actions.append(save, use);
      card.append(actions);
      this.matchRegion.append(card);
      this.matchRegion.hidden = false;
    }

    clearMatch() {
      this.state.match = null;
      this.matchRegion.replaceChildren();
      this.matchRegion.hidden = true;
      this.findButton.disabled = true;
      this.closeAuth(false);
      this.setStatus('');
      this.setAlert('');
      this.updateProgressiveStage();
    }

    updateProgressiveStage() {
      if (!this.fieldsRegion) return;
      var stage = 'application';
      if (this.applicationSelect && this.applicationSelect.value) stage = 'make';
      if (this.makeSelect && this.makeSelect.value) stage = 'model';
      if (this.modelSelect && this.modelSelect.value && this.state.family) {
        stage = this.state.family.requiresVariant && !(this.variantSelect && this.variantSelect.value) ? 'variant' : 'ready';
      }
      if (this.state.match) stage = 'matched';
      this.fieldsRegion.dataset.atfStage = stage;
      if (this.resetButton) {
        this.resetButton.disabled = !Boolean(
          this.applicationSelect && this.applicationSelect.value ||
          this.makeSelect && this.makeSelect.value ||
          this.modelSelect && this.modelSelect.value ||
          this.variantSelect && this.variantSelect.value ||
          this.state.match
        );
      }
    }

    startAgain() {
      this.requests.makes += 1;
      this.requests.models += 1;
      this.state.families = [];
      this.state.family = null;
      this.state.match = null;
      this.applicationSelect.value = '';
      this.syncCustomSelect(this.applicationSelect);
      this.resetSelect(this.makeSelect, this.string('chooseApplicationFirst', 'Choose an application first'));
      this.resetSelect(this.modelSelect, this.string('chooseMakeFirst', 'Choose a make first'));
      this.resetVariant();
      this.savedSelect.value = '';
      this.syncCustomSelect(this.savedSelect);
      this.matchRegion.replaceChildren();
      this.matchRegion.hidden = true;
      this.findButton.disabled = true;
      this.updateFindLabel();
      this.closeAuth(false);
      this.setStatus('');
      this.setAlert('');
      this.updateProgressiveStage();
      var custom = this.customSelects.get(this.applicationSelect);
      if (custom) custom.trigger.focus({ preventScroll: true });
    }

    async useSavedProfile() {
      var option = this.savedSelect.selectedOptions[0];
      if (!option || !option.dataset.profile) return;
      var profile;
      try { profile = Core.sanitizeProfile(JSON.parse(option.dataset.profile)); } catch (error) { return; }
      var restored = await this.restoreProfile(profile);
      if (restored) this.setStatus(this.string('savedSelected', 'Saved application selected.'));
    }

    async restoreProfile(profile) {
      if (!Core.validProfile(profile)) return false;
      if (!this.setSelectByLabel(this.applicationSelect, profile.application)) return false;
      await this.onApplicationChange();
      if (!this.setSelectByLabel(this.makeSelect, profile.make)) return false;
      await this.onMakeChange();
      if (!this.setSelectByLabel(this.modelSelect, profile.modelFamily || profile.model)) return false;
      this.onModelChange();
      if (profile.variant) {
        if (!this.variantSelect || !this.setSelectByLabel(this.variantSelect, profile.variant)) return false;
        this.onVariantChange();
      }
      this.findMatch();
      return Boolean(this.state.match);
    }

    renderSaved(profiles) {
      this.savedSelect.replaceChildren();
      if (!profiles.length) {
        this.savedSelect.append(new Option(this.string('noSavedApplications', 'No saved applications yet'), ''));
        this.savedSelect.disabled = true;
        this.syncCustomSelect(this.savedSelect);
        return;
      }
      this.savedSelect.append(new Option(this.string('savedPlaceholder', 'Choose a saved application'), ''));
      profiles.forEach(function (profile) {
        var option = new Option(profile.name || profile.displayName, profile.id);
        option.dataset.profile = JSON.stringify(profile);
        this.savedSelect.append(option);
      }, this);
      this.savedSelect.disabled = false;
      this.syncCustomSelect(this.savedSelect);
    }

    pendingSave() {
      try {
        var pending = JSON.parse(window.localStorage.getItem(this.config.pendingStorageKey) || 'null');
        if (!pending || !Core.validProfile(pending.profile)) return null;
        if (Date.now() - Number(pending.createdAt || 0) > 24 * 60 * 60 * 1000) return null;
        return pending;
      } catch (error) {
        return null;
      }
    }

    preservePendingSave() {
      if (!this.state.match) return false;
      var target = this.partsFinderTarget();
      if (!target) return false;
      var pending = {
        profile: Core.sanitizeProfile(this.state.match),
        createdAt: Date.now(),
        returnPath: target.pathname,
        sourcePath: window.location.pathname,
        source: 'atf-hero'
      };
      try {
        window.localStorage.setItem(this.config.pendingStorageKey, JSON.stringify(pending));
        return true;
      } catch (error) {
        this.setAlert('This browser could not preserve your selected application.');
        return false;
      }
    }

    saveMatch() {
      if (!this.state.match) return;
      if (this.config.customer && this.config.customer.signedIn) {
        this.persistAccountProfile(this.state.match);
        return;
      }
      if (!this.preservePendingSave()) return;
      if (this.finderFace) this.finderFace.hidden = true;
      this.authOptions.forEach(function (option, index) { option.open = index === 0; });
      this.authPanel.hidden = false;
      this.dataset.atfView = 'auth';
      var firstInput = this.authPanel.querySelector('input');
      window.requestAnimationFrame(() => {
        if (window.matchMedia('(max-width: 620px)').matches) {
          var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        }
        if (firstInput) firstInput.focus({ preventScroll: true });
      });
    }

    closeAuth(restoreFocus) {
      if (this.authPanel) this.authPanel.hidden = true;
      if (this.finderFace) this.finderFace.hidden = false;
      delete this.dataset.atfView;
      if (restoreFocus) {
        var button = this.matchRegion.querySelector('[data-atf-save]');
        if (button) window.requestAnimationFrame(function () { button.focus(); });
      }
    }

    async persistAccountProfile(profile) {
      var endpoint = this.accountEndpoint();
      if (!endpoint) {
        this.setAlert(this.string('accountSaveError', 'We could not save this to your account. Please try again or contact TMP Global.'));
        return false;
      }
      this.setStatus(this.string('savingAccount', 'Saving to your TMP Global account…'));
      this.setAlert('');
      try {
        var data = await this.fetchJSON(endpoint, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'upsert', profile: Core.sanitizeProfile(profile) })
        });
        if (data && data.ok === false) throw new Error('Save rejected');
        var saved = Core.sanitizeProfile(data && data.profile || profile);
        this.storage.save(saved);
        this.renderSaved(this.storage.read());
        this.closeAuth(false);
        this.setStatus(Core.terminology(saved.application, this.config.strings).saved);
        try { window.localStorage.removeItem(this.config.pendingStorageKey); } catch (error) {}
        return true;
      } catch (error) {
        this.setStatus('');
        this.setAlert(this.string('accountSaveError', 'We could not save this to your account. Please try again or contact TMP Global.'));
        return false;
      }
    }

    async loadAccountProfiles() {
      var endpoint = this.accountEndpoint();
      if (!endpoint) return;
      try {
        var data = await this.fetchJSON(endpoint + (endpoint.indexOf('?') === -1 ? '?action=list' : '&action=list'));
        var profiles = Core.rowsFrom(data, ['profiles', 'applications', 'rows']);
        if (profiles.length) {
          this.storage.replace(profiles);
          this.renderSaved(this.storage.read());
        }
      } catch (error) {}
    }

    resumeHeroPendingSave() {
      var pending = this.pendingSave();
      if (!pending || pending.source !== 'atf-hero' || pending.sourcePath !== window.location.pathname) return;
      this.restoreProfile(pending.profile).then((restored) => {
        if (restored) this.persistAccountProfile(pending.profile);
      });
    }

    useDetails() {
      if (!this.state.match) return;
      var target = this.partsFinderTarget();
      if (!target) {
        this.setAlert('The dedicated Parts Finder page has not been configured yet.');
        return;
      }
      var handoff = {
        version: 1,
        action: 'use-details',
        profile: Core.sanitizeProfile(this.state.match),
        createdAt: Date.now(),
        returnPath: target.pathname
      };
      var encoded = JSON.stringify(handoff);
      try { window.sessionStorage.setItem(this.config.handoffStorageKey, encoded); } catch (error) {}
      try { window.localStorage.setItem(this.config.handoffStorageKey, encoded); } catch (error) {}
      target.searchParams.set('tmp_finder', 'hero');
      target.hash = 'tmp-parts-finder';
      window.location.assign(target.href);
    }

    setStatus(message) {
      this.statusRegion.textContent = text(message);
    }

    setAlert(message) {
      this.alertRegion.textContent = text(message);
    }
  }

  customElements.define('tmp-atf-parts-finder', TMPATFPartsFinder);

  var predictiveProductCache = new Map();

  function normalizedSku(value) {
    return text(value).toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function productJSONUrl(href) {
    try {
      var productUrl = new URL(href, window.location.origin);
      if (productUrl.origin !== window.location.origin || productUrl.pathname.indexOf('/products/') === -1) return '';
      return productUrl.origin + productUrl.pathname.replace(/\.js$/, '') + '.js';
    } catch (error) {
      return '';
    }
  }

  function loadPredictiveProduct(url) {
    if (!predictiveProductCache.has(url)) {
      predictiveProductCache.set(url, fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      }).catch(function () { return null; }));
    }
    return predictiveProductCache.get(url);
  }

  function selectPredictiveSku(product, query) {
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    var querySku = normalizedSku(query);
    var exact = variants.find(function (variant) {
      return querySku && normalizedSku(variant && variant.sku) === querySku;
    });
    var selected = exact || variants.find(function (variant) { return text(variant && variant.sku); });
    return text(selected && selected.sku);
  }

  function enhancePredictiveRows(results, section, config) {
    var queryInput = section.querySelector('.atf-pf__search-input');
    var query = queryInput ? queryInput.value : '';
    results.querySelectorAll('#predictive-search-results-products-list .predictive-search__item').forEach(function (link) {
      if (link.dataset.atfSkuState) return;
      var url = productJSONUrl(link.getAttribute('href'));
      if (!url) return;
      link.dataset.atfSkuState = 'loading';
      loadPredictiveProduct(url).then(function (product) {
        var sku = selectPredictiveSku(product, query);
        if (!sku || !link.isConnected) {
          link.dataset.atfSkuState = 'complete';
          return;
        }
        var content = link.querySelector('.predictive-search__item-content');
        if (!content || content.querySelector('.atf-pf__predictive-sku')) return;
        var skuLine = document.createElement('p');
        skuLine.className = 'atf-pf__predictive-sku';
        skuLine.textContent = (text(config.strings && config.strings.predictiveSkuLabel) || 'SKU') + ': ' + sku;
        var price = content.querySelector('.price');
        if (price) content.insertBefore(skuLine, price);
        else content.append(skuLine);
        link.dataset.atfSkuState = 'complete';
      });
    });
  }

  function initPredictiveEnhancements(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = [];
    if (scope.matches && scope.matches('[data-atf-pf-section]')) sections.push(scope);
    scope.querySelectorAll('[data-atf-pf-section]').forEach(function (section) { sections.push(section); });
    sections.forEach(function (section) {
      var results = section.querySelector('.atf-pf__predictive-results');
      if (!results || results.dataset.atfEnhanced === 'true') return;
      var config = {};
      try {
        var script = section.querySelector('[data-atf-config]');
        config = JSON.parse(script ? script.textContent : '{}');
      } catch (error) {}
      results.dataset.atfEnhanced = 'true';
      enhancePredictiveRows(results, section, config);
      new MutationObserver(function () {
        enhancePredictiveRows(results, section, config);
      }).observe(results, { childList: true, subtree: true });

      var predictive = section.querySelector('.atf-pf__predictive');
      var input = section.querySelector('.atf-pf__search-input');
      if (predictive && input) {
        var predictiveWasOpen = predictive.hasAttribute('open');
        var lastScrollAt = 0;
        new MutationObserver(function () {
          if (predictive.hasAttribute('open')) {
            predictiveWasOpen = true;
            return;
          }
          if (performance.now() - lastScrollAt > 120) predictiveWasOpen = false;
        }).observe(predictive, { attributes: true, attributeFilter: ['open'] });
        window.addEventListener('scroll', function () {
          lastScrollAt = performance.now();
          var wasOpen = predictive.hasAttribute('open') || predictiveWasOpen;
          if (!wasOpen || !input.value.trim() || !results.firstElementChild) return;
          window.requestAnimationFrame(function () {
            if (predictive.hasAttribute('open')) return;
            predictive.setAttribute('open', '');
            predictive.setAttribute('results', 'true');
            predictive.isOpen = true;
            input.setAttribute('aria-expanded', 'true');
          });
        }, { capture: true, passive: true });
      }
    });
  }

  initPredictiveEnhancements(document);
  document.addEventListener('shopify:section:load', function (event) {
    initPredictiveEnhancements(event.target);
  });
})();